import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer, Icon, Text, IconContainer } from '..';

const AlertLabelContainer = styled.button`
    min-height: 22px;
    max-height: 30px;
    border: none;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    width: ${({ $width }) => $width || '100%'};
    margin: ${({ $margin }) => $margin || '4px 0'};
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
    ${({ type }) => (type === 'success' || type == 'small') && css`
        background-color: rgb(230, 245, 241);

        ${({ onClick }) => onClick && css`
            &:hover {
                background-color: rgb(210, 235, 230); // ligeramente más oscuro
            }
        `}
    `}

    ${({ type }) => (type === 'error' || type == 'large') && css`
        background-color: #f9e6e8;

        ${({ onClick }) => onClick && css`
            &:hover {
                background-color: #f4cdd2;
            }
        `}
    `}

    ${({ type }) => type === 'medium' && css`
        background-color:rgb(255, 242, 208);
    `}
`;

const getIconName = (type) => {
    if (type === 'success') return 'checkmark-circle';
    if (type === 'error') return 'alert-circle';
    return null;
}

const getColor = (type) => {
    if (type === 'success') return '#1fa02e';
    if (type === 'error') return '#cc2c3b';
    if (type === 'medium') return '#EB963C';
    return '#333333';
}

const AlertLabel = ({ text, type, iconSize = 19, iconName: iconNameProp, iconColor: iconColorProp, width, margin, onClick, color: colorProp, borderIconContainer = 'none', backgroundIconContainer = 'none' }) => {
    const color = colorProp || getColor(type);
    const iconName = iconNameProp || getIconName(type);

    return (
        <AlertLabelContainer type={type} $width={width} $margin={margin}  onClick={onClick}>
            <FlexContainer align="center" gap={5}>
                <IconContainer size={15} style={{ border: borderIconContainer, backgroundColor: backgroundIconContainer }} >
                    {iconName && <Icon name={iconName} size={iconSize} color={color} />}
                </IconContainer>
                <Text text={text} style={{ fontWeight: '600' }} color={color} />
            </FlexContainer>
        </AlertLabelContainer>
    );
};

AlertLabel.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'medium', 'semaphore']),
    iconName: PropTypes.string,
    iconColor: PropTypes.string,
    onClick: PropTypes.func,
};

export default AlertLabel;